'use client';

import { LocationHydration } from 'stores/LocationStore';
import dynamic from 'next/dynamic';

import { InstantSearch } from 'react-instantsearch';
import searchClient from 'utils/algolia';
import { ALGOLIA_INITIAL_SEARCH, ALGOLIA_INDEX_NAME } from 'constants/algolia';

import HeaderFilters from './components/HeaderFilters/HeaderFilters';
import * as styles from './NewHeaderContext.css';

const AlgoliaSearch = dynamic(() => import('components/AlgoliaSearch/AlgoliaSearch'), { ssr: false });

const initialUiState = {
  [ALGOLIA_INDEX_NAME]: { query: ALGOLIA_INITIAL_SEARCH },
};

function NewHeaderContext({
  locationHydration,
  isNavbarCollapsed = false,
  variant,
  isDark = false,
  hasMossColor = false
}: {
  locationHydration: LocationHydration;
  isNavbarCollapsed?: boolean;
  variant?: 'default' | 'primary' | 'dark';
  isDark?: boolean;
  hasMossColor?: boolean;
}) {
  return (
    <div className={`${styles.container} ${isNavbarCollapsed && styles.colapsedContainer}`}>
      <InstantSearch searchClient={searchClient} indexName={ALGOLIA_INDEX_NAME} insights initialUiState={initialUiState}>
        <AlgoliaSearch isNavbarCollapsed={isNavbarCollapsed} isDark={isDark} hasMossColor={hasMossColor} />
      </InstantSearch>
      <HeaderFilters locationHydration={locationHydration} isNavbarCollapsed={isNavbarCollapsed} variant={variant} />
    </div>
  );
}

export default NewHeaderContext;
